export const ROOT_URL = `${process.env.REACT_APP_BASE_URL}`;
export type ROOT_URL = typeof ROOT_URL;

export const REGISTER_USER_URL = 'register/business-plus-2020';
export type REGISTER_USER_URL = typeof REGISTER_USER_URL;
